<template>
  <v-dialog v-model="dialog" max-width="620" persistent>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-dialog v-model="deleteDialog" max-width="480">
      <v-card>
        <v-card-title
          >Är du säker på att du vill radera dagordning
          {{ agenda.id }}?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Nej</v-btn>
          <v-btn text color="primary" type="submit" @click="remove">Ja</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-card-title class="color-a">
        Redigerar dagordning "{{ agenda.id }}"
      </v-card-title>
      <v-card-text>
        <agenda-form
          ref="form"
          :agenda="agenda"
          :hasAttachment="!!agenda.attachment"
          @file-selected="onFileSelected"
        ></agenda-form>
        <div v-if="agenda.attachment" style="margin-bottom: 12px;">
          <v-chip close @click:close="deleteAttachment">
            <v-icon left>mdi-paperclip</v-icon>
            Nuvarande bilaga: {{ getAttachmentName(agenda.attachment) }}
          </v-chip>
        </div>
        <v-btn text @click="deleteDialog = true"
          ><v-icon left>mdi-delete</v-icon> Radera dagordning</v-btn
        >
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Avbryt</v-btn>
        <v-btn text color="primary" type="submit" @click="save">Spara</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AgendaForm from "@/components/agenda/AgendaForm.vue";

export default {
  props: {
    meeting: Object,
    id: String,
    agenda: Object
  },
  components: { AgendaForm },
  data() {
    return {
      dialog: false,
      deleteDialog: false,
      selectedFile: null
    };
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.selectedFile = null;
      }
    }
  },
  methods: {
    onFileSelected(file) {
      this.selectedFile = file;
    },
    getAttachmentName(attachmentUrl) {
      if (!attachmentUrl) return "";
      const parts = attachmentUrl.split("/");
      const fileName = parts[parts.length - 1];
      const decoded = decodeURIComponent(fileName.split("?")[0]);
      const withoutUid = decoded.replace(/^[^_]+_/, "");
      return withoutUid;
    },
    async deleteAttachment() {
      const currentItem = this.meeting.agenda.find(itm => itm.uid === this.id);
      if (currentItem && currentItem.attachmentFileName) {
        await this.$store.dispatch("meetings/deleteAgendaAttachment", {
          meetingId: this.meeting.id,
          fileName: currentItem.attachmentFileName
        });
      }

      const newAgendaArray = this.meeting.agenda.map(itm => {
        if (itm.uid === this.id) {
          let newObj = { ...itm };
          delete newObj.attachment;
          delete newObj.attachmentFileName;
          return newObj;
        } else {
          return itm;
        }
      });

      await this.$store.dispatch("meetings/editAgendaItem", {
        meetingId: this.meeting.id,
        newAgendaArray
      });
    },
    close() {
      this.dialog = false;
      this.selectedFile = null;
    },
    async save() {
      const currentItem = this.meeting.agenda.find(itm => itm.uid === this.id);
      let attachmentUrl = currentItem?.attachment || null;
      let attachmentFileName = currentItem?.attachmentFileName || null;

      if (this.selectedFile) {
        if (currentItem?.attachmentFileName) {
          await this.$store.dispatch("meetings/deleteAgendaAttachment", {
            meetingId: this.meeting.id,
            fileName: currentItem.attachmentFileName
          });
        }

        const result = await this.$store.dispatch(
          "meetings/uploadAgendaAttachment",
          {
            meetingId: this.meeting.id,
            agendaUid: this.id,
            file: this.selectedFile
          }
        );

        if (result) {
          attachmentUrl = result.url;
          attachmentFileName = result.fileName;
        }
      }

      const newAgendaArray = this.meeting.agenda.map(itm => {
        if (itm.uid === this.id) {
          let newObj = { ...this.$refs.form.form };
          newObj.uid = this.id;
          if (attachmentUrl && attachmentFileName) {
            newObj.attachment = attachmentUrl;
            newObj.attachmentFileName = attachmentFileName;
          }
          return newObj;
        } else {
          return itm;
        }
      });
      const success = await this.$store.dispatch("meetings/editAgendaItem", {
        meetingId: this.meeting.id,
        newAgendaArray
      });
      if (success) {
        this.close();
      }
    },
    async remove() {
      const newAgendaArray = this.meeting.agenda.filter(
        itm => itm.uid !== this.id
      );

      const success = await this.$store.dispatch("meetings/editAgendaItem", {
        meetingId: this.meeting.id,
        newAgendaArray
      });
      if (success) {
        this.close();
      }
    }
  }
};
</script>

<style></style>
